import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
// import { colors } from '../../styles';

const styles = css`
`;

function Specifications({ home, community, plan }) {
  return (
    <div className={styles}>
      <div className="DetailSection">
        <div className="ScrollTarget" id="specifications" />
        <AccordionToggle
          openOnId="specifications"
          button={({ contentVisible }) => (
            <div className="container DetailSection_headingWrapper">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Specifications</h3>
            </div>
          )}
          noToggleDesktop
        >
          <div className="container">
            <ul className="DetailSection_table">
              <li className="row">
                <div className="col-4 pr-0">
                  <div className="DetailSection_tableLabel">
                    Address
                  </div>
                </div>
                <div className="col-8 pl-0">
                  <div className="DetailSection_tableContent">
                    { get(home, 'address.streetAddress') }
                  </div>
                </div>
              </li>
              <li className="row">
                <div className="col-4 pr-0">
                  <div className="DetailSection_tableLabel">
                    City, St, Zip
                  </div>
                </div>
                <div className="col-8 pl-0">
                  <div className="DetailSection_tableContent">
                    {`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')} ${get(home, 'address.postalCode')}`}
                  </div>
                </div>
              </li>
              {
                get(home, 'beds') > 0 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Bedrooms
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'beds')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'bathsFull') > 0 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Full Baths
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'bathsFull')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'bathsHalf') > 0 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Half Baths
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'bathsHalf')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'sqft') > 0 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Sq Ft
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {numeral(get(home, 'sqft')).format('0,0')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'price') > 10000 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Price
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {numeral(get(home, 'price')).format('$0,0')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'moveInDate') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Estimated Completion Date
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {moment(get(home, 'moveInDate')).format('MMMM D, YYYY')}
                    </div>
                  </div>
                </li>
              }
              {
                get(community, 'name') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Community
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(community, 'name')}
                    </div>
                  </div>
                </li>
              }
              {
                get(plan, 'name') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Plan
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(plan, 'name')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'builder_name') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Builder
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'builder_name')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'status') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Status
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'status')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'lot') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Lot
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'lot')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'lotSize') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Lot Size
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {numeral(get(home, 'lotSize')).format('0,0')} Sq Ft
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'mls') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      MLS
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      #{get(home, 'mls')}
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'garages') > 0 &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Garages
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'garages')}-Car
                    </div>
                  </div>
                </li>
              }
              {
                get(home, 'masterBedLocation') &&
                <li className="row">
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      Master Bedroom Location
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {get(home, 'masterBedLocation') === 'up' ? 'Upstairs' : 'Main Floor'}
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        </AccordionToggle>
      </div>
    </div>
  );
}

Specifications.propTypes = {
  home: PropTypes.object.isRequired,
  community: PropTypes.object,
  plan: PropTypes.object,
};

Specifications.defaultProps = {
  community: undefined,
  plan: undefined,
};

export default withData(
  {
    home: true,
    community: true,
    plan: true,
  },
  {
    required: {
      home: true,
    },
  },
)(Specifications);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/Specifications.js